export default __webpack_public_path__ + "static/media/name_the_state.2aa2c9bd.png";